<script setup lang="ts">
import { storeToRefs } from 'pinia'

import VAddCartButton from '~/components/ui/Buttons/VAddCartButton.vue'
import VBookmark from '~/components/ui/VBookmark.vue'

import { useUserStore } from '~/stores/user'

import type { Influencer, StatsV3Influencer } from '~/types/influencer'

type Props = {
  isContest?: boolean
  influencer: Influencer | StatsV3Influencer
  isSelected: boolean
  isAway: boolean
}

withDefaults(defineProps<Props>(), {
  isContest: false,
})

const route = useRoute()

const { IS_INF: USER_IS_INF, IS_BAND: USER_IS_BAND } =
  storeToRefs(useUserStore())

const displaySelf = computed<boolean>(() => {
  if (route.path.includes('influencer/list/tags/')) return USER_IS_BAND.value
  else return !USER_IS_INF.value
})
</script>

<template>
  <div v-if="displaySelf" class="bottomContentMainCardContainer">
    <div class="content">
      <VBookmark
        data-test-id="influencerCardFooterBookmarkCTA"
        :influencer="influencer"
        :hide-tooltip-arrow="true"
      />
      <VAddCartButton
        data-test-id="influencerCardFooterToggleCTA"
        :influencer="influencer"
        :is-selected="isSelected"
        :is-away="isAway"
        :is-contest="isContest"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.bottomContentMainCardContainer {
  position: relative;
  width: 100%;
}

.content {
  display: flex;
  align-items: center;
  padding: 0 20px 20px;
  gap: 24px;
  justify-content: flex-end;
}

.fa-bookmark {
  color: var(--color-darker-grey);
  font-size: var(--font-size-big);
}

.fa-bookmark:hover {
  @apply tw-rounded-xs tw-bg-clip-text tw-text-orange-500 tw-text-transparent;
}

.popupWidthWrapper {
  width: 100vw;
  max-width: 555px;
}

@media screen and (max-width: 767px) {
  .popupWidthWrapper {
    max-width: unset;
    height: 100%;
  }
}
</style>
